import { SystemIcons, SystemIconsProps } from '@almbrand/systemicons';
import { ThemeUnion } from '@almbrand/systemicons/dist/cjs/types/icon';
import { ThemeNames } from 'constantsValues';
import { PageContext } from 'context/PageContext';
import { useContext } from 'react';

export const SystemIconsComponent: React.FC<SystemIconsProps<ThemeUnion>> = (props) => {
	const pageContext = useContext(PageContext);
	const { theme } = pageContext;
	const themeName = ThemeNames[theme];

	return (
		<SystemIcons
			icon={props.icon}
			fill={props.fill}
			width={props.width}
			height={props.height}
			themeName={themeName}
		/>
	);
};
